import axios, { AxiosInstance } from 'axios';
import { NetworkInstanceType, NetworkInstancesType } from './types';
import environment from 'modules/core/constants/environment';
import { getErrorMessage } from './errorMap';

const NETWORK_INSTANCES: NetworkInstancesType = {};

const createNetworkInstance = (): NetworkInstanceType => {
	const controller = new AbortController();

	const axiosInstance = axios.create({
		signal: controller.signal,
		baseURL: environment.BASE_URL,
	});

	axiosInstance.interceptors.response.use(
		response => response,
		error => {
			if (error.response?.data?.message != null) {
				error.response.data.message = getErrorMessage(error);
			}
			return Promise.reject(error);
		},
	);

	return {
		controller,
		instance: axiosInstance,
	};
};

export const getInstance = (pathname: string): AxiosInstance => {
	if (
		NETWORK_INSTANCES[pathname] &&
		!NETWORK_INSTANCES[pathname].controller.signal.aborted
	) {
		return NETWORK_INSTANCES[pathname].instance;
	}

	const networkInstance = createNetworkInstance();
	NETWORK_INSTANCES[pathname] = networkInstance;
	return networkInstance.instance;
};

export const cancelPreviousPageRequests = (previousPath: string) => {
	if (
		NETWORK_INSTANCES[previousPath] &&
		!NETWORK_INSTANCES[previousPath].controller.signal.aborted
	) {
		NETWORK_INSTANCES[previousPath].controller.abort();
	}
};
